function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    fill: "rgb(15.294118%,51.372549%,31.764706%)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fillOpacity: 1
    },
    d: "M 16 20 C 18.214844 20 19.988281 18.214844 19.988281 16 L 20 8 C 20 5.785156 18.214844 4 16 4 C 13.785156 4 12 5.785156 12 8 L 12 16 C 12 18.214844 13.785156 20 16 20 Z M 23.066406 16 C 23.066406 20 19.679688 22.800781 16 22.800781 C 12.320312 22.800781 8.933594 20 8.933594 16 L 6.667969 16 C 6.667969 20.558594 10.292969 24.308594 14.667969 24.960938 L 14.667969 29.332031 L 17.332031 29.332031 L 17.332031 24.960938 C 21.707031 24.320312 25.332031 20.558594 25.332031 16 Z M 23.066406 16 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.bef3da1b.svg";
export { ForwardRef as ReactComponent };